export const CUSTOMIZE_SIDEBAR_MENU_ITEM_TEST_ID = 'gsn-customize-sidebar';
export const MORE_MENU_TEST_ID = 'gsn-more-menu';
